import { useQueryClient } from 'react-query';

import { queryKey } from '../../documents.query-keys';

export const useInvalidateAllDocuments = () => {
    const queryClient = useQueryClient();

    return () => {
        queryClient.invalidateQueries(queryKey.documents());
    };
};
